// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import Image from 'presentations/views/components/atoms/Image';
import Icon from 'presentations/views/components/atoms/Icon';
import styled from '@emotion/styled';
import { mediaMax, mediaMin, spacing } from 'presentations/views/styles';
import { gray05, gray06 } from 'presentations/views/styles/color';
import Headline from 'presentations/views/components/atoms/Headline';
import Progress from 'presentations/views/components/atoms/Progress';
import { transformImageUrl } from 'presentations/assets';
import Avatar from 'presentations/views/components/atoms/Avatar';
import { TeamListItem } from 'presentations/api/schema/team';

interface Props {
  teams: TeamListItem[];
  onClick?: any;
  isLoading?: any;
}
const Component = (props: Props) => {
  const t = translateInComponent(translations);
  return (
    <Container>
      <HeadlineContainer>
        <Headline variant="h2">{t('title')}</Headline>
      </HeadlineContainer>
      <Description>
        <Text>{t('description')}</Text>
      </Description>
      {props.isLoading ? (
        <Progress />
      ) : (
        <LoginTeamList>
          {props.teams.map((team) => {
            const imageUrl = transformImageUrl(team.profileImage, {
              width: 80,
              height: 80,
            });
            const name = team.name || team.uid;
            return (
              <LoginTeamListItem
                key={team.id}
                role="button"
                onClick={(e) => props.onClick(team)}
              >
                {imageUrl ? (
                  <LogoImage src={imageUrl} alt={name} />
                ) : (
                  <Avatar>{name[0]}</Avatar>
                )}
                <Name>{name}</Name>
              </LoginTeamListItem>
            );
          })}
        </LoginTeamList>
      )}
    </Container>
  );
};
export default Component;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoginTeamList = styled.ul`
  margin-bottom: ${spacing(32)};
  border-top: 1px solid ${gray05};
  ${mediaMin.smartphone} {
    min-width: 360px;
  }
  ${mediaMax.smartphone} {
    width: 100%;
  }
`;
const LoginTeamListItem = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  :hover {
    background-color: ${gray06};
  }
  padding: ${spacing(16)} 0;
  border-bottom: 1px solid ${gray05};
`;
const Name = styled.span`
  margin-left: ${spacing(16)};
`;
const HeadlineContainer = styled.div`
  margin-top: ${spacing(88)};
  margin-bottom: ${spacing(32)};
  ${mediaMax.tablet} {
    margin-top: ${spacing(48)};
  }
`;
const Description = styled.div`
  margin-bottom: ${spacing(40)};
`;
const Text = styled.span``;
const LogoImage = styled(Image)`
  width: 40px;
`;
